import { RootState } from '../reducers';

export const getIsAuth = (state: RootState) => state.auth.isAuth;
export const getAuthUser = (state: RootState) => state.auth.user;
export const isAuthLoading = (state: RootState) => state.auth.isLoading;
export const getTimezone = (state: RootState) => state.auth.timezone;
export const getResetUserCognObj = (state: RootState) => state.auth.resetUserCognObj;
